<!--
  @component
  Generates a voronoi layer using [d3-delauney](https://github.com/d3/d3-delauney).
 -->
<script>
  import { getContext } from "svelte";
  import { uniques, raise } from "layercake";
  import { Delaunay } from "d3-delaunay";

  const { data, xGet, yScale, width, height } = getContext("LayerCake");

  let {
    points,
    stroke = undefined,
    activeIndex = $bindable(null),
    activeKey = $bindable(null),
    hover = false,
    onclick = () => {}
  } = $props();

  function yGet(d) {
    return $yScale(d.value);
  }
  let pointsXY = $derived(
    points.map((d) => {
      const point = [$xGet(d), yGet(d)];
      point.data = d;
      return point;
    })
  );

  let voronoiWidth = $derived(Math.max($width, 1));
  let voronoiHeight = $derived(Math.max($height, 1));

  let voronoi = $derived(Delaunay.from(pointsXY).voronoi([0, 0, voronoiWidth, voronoiHeight]));
</script>

{#each pointsXY as point, i}
  <path
    style="stroke: {stroke}"
    class="voronoi-cell"
    d={voronoi.renderCell(i)}
    onmouseleave={() => {
      activeIndex = null;
    }}
    onmousemove={() => {
      activeIndex = i;
    }}
    onfocus={() => {
      activeIndex = i;
    }}
    onclick={() => {
      onclick(points[i]);
    }}
    role="tooltip"
  ></path>
{/each}

<style>
  .voronoi-cell {
    fill: none;
    stroke: none;
    pointer-events: all;
    outline: none;
  }
</style>
